
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/[[...slug]]",
      function () {
        return require("private-next-pages/my-account/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-account/[[...slug]]"])
      });
    }
  